<div provide-parent-form>
	<div class="explanation-text">
		<p>{{ "FITMODE_VISUALISATION_EXPLANATION" | translate:entityDetails }}</p>
	</div>
	<div class="explanation-text-short">
		<p>{{ "FITMODE_NO_IMAGES_EXPLANATION" | translate:entityDetails }}</p>
	</div>

	<div class="fitmode-container">
		<div *ngFor="let fitmode of fitmodes" class="fitmode-item">
			<div class="bb-radio">
				<input type="radio" [id]="'fit-' + fitmode" [(ngModel)]="entityFitmode" (ngModelChange)="inputChanged(fitmode)" name="fitmode" [value]="('FIT_' + fitmode) | uppercase" >
				<span></span>
			</div>
			<label [for]="'fit-' + fitmode">
				<h3 class="ng-binding">{{ 'FIT_' + fitmode | uppercase | translate }}</h3>
				<p class="ng-binding">{{ 'FIT_' + fitmode + '_DESCRIPTION' | uppercase | translate:entityDetails }}</p>
				<div class="example-container" [ngClass]="fitmode">
					<div *ngFor="let example of examples[fitmode]" class="example" [ngClass]="example.class">
						<div class="placeholder"></div>
					</div>
				</div>
			</label>
		</div>
	</div>
</div>